export default {
  DEV_CHH: 'dev_chh',
  DEV_MICE: 'dev_mice',
  PROD_CHH: 'prod_chh',
  PROD_MICE: 'prod_mice',
  TEST_CHH: 'test_chh',
  TEST_MICE: 'test_mice',
}
